<template>
  <router-view />
</template>

<style>
@font-face {
  font-family: "Segoe UI Italic";
  src: url("./assets/segoe1.ttf");
}
@font-face {
  font-family: "Segoe UI";
  src: url("./assets/segoe2.ttf");
}
@font-face {
  font-family: "Segoe UI Light Italic";
  src: url("./assets/segoe3.ttf");
}
@font-face {
  font-family: "Segoe UI Light";
  src: url("./assets/segoelight.ttf");
}

* {
  font-family: "Segoe UI";
}
</style>
